export interface EventosFilters {
  businessClientId: number | null;
  fromDate: string | null;
  toDate: string | null;
  search: string | null;
}

export interface EventosColumnVisibility {
  name: boolean;
  client: boolean;
  dates: boolean;
  status: boolean;
}

export const eventosColumnLabels: Record<
  keyof EventosColumnVisibility,
  string
> = {
  name: 'Nombre del evento',
  client: 'Cliente',
  dates: 'Fechas',
  status: 'Estado'
};

export interface EventosState {
  filters: EventosFilters;
  page: number;
  rowsPerPage: number;
  columnVisibility: EventosColumnVisibility;
}

const STORAGE_KEY = 'eventosListState';

export const getDefaultFilters = (): EventosFilters => ({
  businessClientId: null,
  fromDate: null,
  toDate: null,
  search: null
});

export const getDefaultColumnVisibility = (): EventosColumnVisibility => ({
  name: true,
  client: true,
  dates: true,
  status: true
});

const getDefaultState = (): EventosState => ({
  filters: getDefaultFilters(),
  page: 1,
  rowsPerPage: 10,
  columnVisibility: getDefaultColumnVisibility()
});

export const loadStateFromLocalStorage = (): EventosState => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      return {
        ...getDefaultState(),
        ...parsed,
        filters: {
          ...getDefaultFilters(),
          ...(parsed.filters ?? {})
        },
        columnVisibility: {
          ...getDefaultColumnVisibility(),
          ...(parsed.columnVisibility ?? {})
        }
      };
    }
  } catch (error) {
    console.error('Error loading eventos list state:', error);
  }
  return getDefaultState();
};

export const saveStateToLocalStorage = (state: EventosState): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (error) {
    console.error('Error saving eventos list state:', error);
  }
};
